<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex xs12 sm12 md6 lg1 class="text-center">
          <button
            :class="{ 'pulse-ring': isRecording, 'recording': isRecording, 'unsupported': !isRecording }"
            class="record-button"
            @click="isRecording ? stopRecording() : startRecording()">
            <div class="start-recording" v-if="!isRecording" >
              <div class="mic-icon">
                <v-icon color="white">mic</v-icon>
              </div>
            </div>
            <div class="stop-recording" v-if="isRecording">
              <v-icon color="white">mdi-square</v-icon>
            </div>
          </button>
        </v-flex>
        <v-flex class="d-none d-sm-flex">
          <p v-if="isRecording" class="text-h6">Recording...</p>
          <p v-else class="text-h6">Click to record</p>
        </v-flex>
      </v-layout>
      <v-row no-gutters>
        <v-col class="text-center lg-1 md-6 sm-12 xs-12">
          
        </v-col>
        <v-col class="d-sm-none d-xs-none d-md-flex">
        </v-col>
      </v-row>
      
      <v-row>
        <audio v-if="audioUrl" :src="audioUrl" controls></audio>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RecordRTC from 'recordrtc';

export default {
  emits: ['recording-finished'],
  data() {
    return {
      isRecording: false,
      recorder: null,
      stream: null,
      audioUrl: null
    }
  },
  methods: {
    async startRecording() {
      this.audioUrl = null;
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.recorder = new RecordRTC(this.stream, {
          type: 'audio',
          mimeType: 'audio/mp4'
        });
        this.recorder.startRecording();
        this.isRecording = true;
      } catch (error) {
        console.error('Error:', error);
      }
    },
    async stopRecording() {
      return new Promise(resolve => {
        this.recorder.stopRecording(() => {
          const blob = this.recorder.getBlob();
          this.$emit('recording-finished', blob);
          this.audioUrl = URL.createObjectURL(blob);
          this.isRecording = false;
          this.stream.getTracks().forEach(track => track.stop());
          resolve();
        });
      });
    },

    resetAudioRecorder() {
      this.stopRecording();
      this.audioUrl = null;
    }
  }
}
</script>
<style scoped>
.record-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(145deg, #ff3b30, #ff453a);
  border: none;
  box-shadow: 
    0 4px 20px rgba(255, 59, 48, 0.3),
    0 7px 30px -5px rgba(255, 59, 48, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  position: relative;
  overflow: hidden;
}

.pulse-ring {
  width: 52px;
  height: 52px;
  background: #ff4444;
  border-radius: 50%;
  margin-right: 8px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(255, 68, 68, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(255, 68, 68, 0); }
}
</style>